<!--分拣配送 分拣差异查询 12508-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="客户：" v-if="是团餐客户列表">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable>
              <el-option v-for="item in customer" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户：" v-if="是供应商客户列表">
            <el-select size="medium" v-model="searchForm.SUPPLIER_ID" filterable placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
                <span style="float: left">{{ item.AB_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：" v-if="是团餐客户列表">
            <el-input size="medium" v-model="searchForm.NAME" placeholder="请选择产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称：" v-if="是供应商客户列表">
            <el-input size="medium" v-model="searchForm.SUPPLIER_NAME" placeholder="请选择产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="送货日期：" v-if="是团餐客户列表">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" clearable value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="送货日期：" v-if="是供应商客户列表">
            <el-date-picker size="medium" v-model="searchForm.SUPPLIER_DATE" type="date" placeholder="选择日期" clearable value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" class="btn" type="primary" @click="query">筛选</el-button>
            <el-button size="medium" class="btn" type="primary" plain @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick" v-model="客户类型">
          <el-tab-pane label="团餐客户" name="团餐客户">
            <el-table :data="tableData" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
              <el-table-column label="产品名称" prop="NAME" min-width="100px"></el-table-column>
              <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
              <el-table-column label="订购数量" prop="PRODUCT_COUNT" min-width="100px"></el-table-column>
              <el-table-column label="已分拣数量" prop="NEED_COUNT"></el-table-column>
              <el-table-column label="未分拣数量" prop="NOSEND_COUNT" min-width="100px"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商客户" name="供应商客户">
            <el-table :data="supplierTableData" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
              <el-table-column label="产品名称" prop="NAME" min-width="100px"></el-table-column>
              <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
              <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
              <el-table-column label="订购数量" prop="PRODUCT_COUNT" min-width="100px"></el-table-column>
              <el-table-column label="已分拣数量" prop="NEED_COUNT"></el-table-column>
              <el-table-column label="未分拣数量" prop="NOSEND_COUNT" min-width="100px"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right" v-if="是团餐客户列表">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
      <el-col :span="24" style="text-align: right" v-if="是供应商客户列表">
        <el-pagination @current-change="supplierHandleCurrentChange" :current-page.sync="supplierCurrentPage" :page-size="supplierPageSize"
          layout="total,prev, pager, next, jumper" :total="supplierTotalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { selectTCFun } from 'api/sellOrder';
import { supplierCusFun } from 'api/customerManage';
// import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        TC_ID: '',
        NAME: '',
        data: '',
        SUPPLIER_DATE: '',
        SUPPLIER_ID: '',
        SUPPLIER_NAME: '',
      },
      currentOrderFlag: 0,
      tableData: [],
      supplierTableData: [],
      customer: [],
      supplierList: [],
      currentPage: 1,
      pageSize: 10,
      客户类型: '团餐客户',
      totalCount: 0,
      supplierCurrentPage: 1,
      supplierPageSize: 10,
      supplierTotalCount: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.分拣差异查询存储数据) {
      this.客户类型 = this.分拣差异查询存储数据.客户类型;
      this.searchForm = this.分拣差异查询存储数据.CONDITION;
      this.currentPage = this.分拣差异查询存储数据.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (this.客户类型 == '团餐客户') {
      this.querryData();// 获取团餐客户订单列表
    } else {
      this.querrySupplierData();// 获取供应商订单列表
    }
    this.queryCustomer();// 拉取客户筛选列表
    this.querySupplierList();// 拉取供应商筛选列表
  },
  computed: {
    // 上一次 搜索存储的条件
    分拣差异查询存储数据() {
      return this.$store.state.分拣差异查询存储数据;
    },
    是团餐客户列表() {
      return this.客户类型 == '团餐客户';
    },
    是供应商客户列表() {
      return this.客户类型 == '供应商客户';
    },
  },
  methods: {
    // 切换供应商、团餐客户
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      if (this.客户类型 == '团餐客户') {
        this.querryData();
      } else {
        this.querrySupplierData();
      }
    },
    // 获取团餐客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          this.customer = result[0].company;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取供应商客户
    querySupplierList() {
      const params = {};
      supplierCusFun(params)
        .then((res) => {
          if (res.length !== 0) {
            this.supplierList = res[0].list;
          } else {
            this.supplierList = [];
          }
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // 筛选
    query() {
      this.currentPage = 1;
      this.supplierCurrentPage = 1;
      if (this.客户类型 == '团餐客户') {
        this.querryData();
      } else {
        this.querrySupplierData();
      }
    },
    // ----------团餐客户数据
    querryData() {
      const params = {
        SERVICE_ID: '10021',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.date) {
        params.SEND_DAY = this.searchForm.date;
      }
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      this.loading = true;
      http.post(params).then((result) => {
        this.tableData = result[0].LIST;
        this.totalCount = result[0].TOTAL_COUNT;
        this.$store.dispatch('设置分拣差异查询存储数据', {
          客户类型: this.客户类型,
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // ----------供应商客户数据
    querrySupplierData() {
      const params = {
        SERVICE_ID: '10021',
        OTYPE: 8,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PAGESIZE: this.supplierPageSize,
        PAGEINDEX: this.supplierCurrentPage - 1,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.SUPPLIER_DATE) {
        params.SEND_DAY = this.searchForm.SUPPLIER_DATE;
      }
      if (this.searchForm.SUPPLIER_NAME) {
        params.PRODUCT_NAME = this.searchForm.SUPPLIER_NAME;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.GYS_ID = this.searchForm.SUPPLIER_ID;
      }
      this.loading = true;
      http.post(params).then((result) => {
        this.supplierTableData = result[0].LIST;
        this.supplierTotalCount = result[0].TOTAL_COUNT;
        this.$store.dispatch('设置分拣差异查询存储数据', {
          客户类型: this.客户类型,
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.supplierCurrentPage,
        });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 导出
    exportData() {
      // 团餐客户导出
      if (this.currentOrderFlag == 0) {
        if (document.body.style.cursor === 'wait') {
        } else {
          document.body.style.cursor = 'wait';
          try {
            const params = {
              SERVICE_ID: '10021',
              OTYPE: 7,
              USER_ID: sessionStorage.getItem('userId'),
              SESSION: sessionStorage.getItem('session'),
              SUPPLIER_ID: sessionStorage.getItem('tcId'),
            };
            if (this.searchForm.date) {
              params.SEND_DAY = this.searchForm.date;
            } else {
              this.$message.show({ text: '请选择导出的送货日期', type: 'warning' });
              return;
            }
            if (this.searchForm.NAME) {
              params.PRODUCT_NAME = this.searchForm.NAME;
            }
            if (this.searchForm.TC_ID) {
              params.TC_ID = this.searchForm.TC_ID;
            }
            http.post(params).then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
          } finally {}
        }
        // 供应商客户导出
      } else {
        if (document.body.style.cursor === 'wait') {
        } else {
          document.body.style.cursor = 'wait';
          try {
            const params = {
              SERVICE_ID: '10021',
              OTYPE: 9,
              USER_ID: sessionStorage.getItem('userId'),
              SESSION: sessionStorage.getItem('session'),
              SUPPLIER_ID: sessionStorage.getItem('tcId'),
            };
            if (this.searchForm.SUPPLIER_DATE) {
              params.SEND_DAY = this.searchForm.SUPPLIER_DATE;
            } else {
              this.$message.show({ text: '请选择导出的送货日期', type: 'warning' });
              return;
            }
            if (this.searchForm.SUPPLIER_NAME) {
              params.PRODUCT_NAME = this.searchForm.SUPPLIER_NAME;
            }
            if (this.searchForm.SUPPLIER_ID) {
              params.GYS_ID = this.searchForm.SUPPLIER_ID;
            }
            http.post(params).then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
          } finally {}
        }
      }
    },
    // 团餐分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.querryData();
    },
    // 供应商分页
    supplierHandleCurrentChange(e) {
      this.spplierCurrentPage = e;
      this.querrySupplierData();
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sortingVarianceQuery.vue